<template>
  <v-layout row wrap fluid>
    <v-flex>
      <v-card id="newEmployee" class="add-card max-shadow">
        <v-toolbar color="white" flat>
          <v-btn icon @click="$router.back()">
            <v-icon color="iconColor"> arrow_back </v-icon>
          </v-btn>
          <v-toolbar-title> New Employee </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn color="primary" flat @click="addEmployee">
              <v-layout v-if="loading" row wrap justify-center>
                <v-progress-circular
                  :size="24"
                  :width="3"
                  indeterminate
                  color="primary"
                />
              </v-layout>
              <v-layout v-else row wrap justify-center> add </v-layout>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-form ref="form">
          <v-container grid-list-lg class="pa-3" fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  ref="name"
                  v-model="employee.name"
                  :rules="[(v) => !!v || 'Employee Name is required']"
                  autofocus
                  label="Employee Name"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  ref="email"
                  v-model="employee.email"
                  :rules="validationRules.email"
                  label="Employee Email"
                  type="email"
                  required
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  ref="phone"
                  v-model="employee.phone"
                  prefix="+91"
                  mask="##########"
                  label="Employee Phone"
                />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  ref="designation"
                  v-model="employee.designation"
                  label="Designation"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="0" bottom>
        {{ snackbarMessage }}
        <v-btn flat @click.native="snackbar = false"> Close </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from '@/mixins/validation-rules';
import { firestore, auth } from '@/firebase';
import { generateUID } from '@/utils';
import _some from 'lodash/some';
import axios from 'axios';
import { settings } from '../../../utils/settings';

export default {
  name: 'NewEmployee',
  mixins: [validationRules],
  data() {
    return {
      employee: {
        name: this.$route.query.name || '',
        email: this.$route.query.email || '',
        phone: '',
        department: '',
      },
      employees: [],
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'primary',
      cid: this.$route.query.cid || null,
      cName: this.$route.query.cName || null,
      loading: false,
    };
  },
  computed: {
    employeeFormatted() {
      return {
        name: this.employee.name,
        email: this.employee.email,
        phone: `+91${this.employee.phone}`,
        designation: this.employee.designation || null,
      };
    },
  },
  created() {
    firestore
      .collection('tenants')
      .doc(this.$store.state.profile.cid)
      .collection('employees')
      .get()
      .then((employeesSnapshot) => {
        this.employees = [];
        employeesSnapshot.forEach((employeeSnapshot) => {
          const employee = employeeSnapshot.data();
          employee.id = employeeSnapshot.id;
          this.employees.push(employee);
        });
      });
  },
  methods: {
    getIdToken() {
      return auth.currentUser.getIdToken(true);
    },

    async addEmployee() {
      if (this.loading) return;
      
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      //if cid is not null, then this is from access request add employee
      //if not null, then check if cid is same as admin(if not he is not authorized to)
      if (this.cid) {
        if (this.$store.state.profile.cid != this.cid) {
          this.snackbarMessage = `Unnauthorized! Please login to ${this.cName} admin dashboard.`;
          this.snackbarColor = 'error';
          this.snackbar = true;
          this.loading = false;
          return;
        }
      }
      if (
        _some(this.employees, (o) => o.email === this.employeeFormatted.email)
      ) {
        this.snackbarMessage = 'Duplicate Record';
        this.snackbarColor = 'error';
        this.snackbar = true;
      } else {
        const idToken = await this.getIdToken();

        await axios
          .post(
            `${settings.dashboard_url}/api/user/exists`,
            {
              user: this.employeeFormatted,
            },
            {
              headers: {
                Authorization: `idToken ${idToken}`,
              },
            }
          )
          .then(() => {
            firestore
              .collection('tenants')
              .doc(this.$store.state.profile.cid)
              .collection('employees')
              .doc(generateUID())
              .set(this.employeeFormatted);

            this.$router.push('/admin/employees');
          })
          .catch((error) => {
            const errorMessages = ((error.response || {}).data || {}).error || error.message
            console.log(errorMessages);
            this.snackbarMessage = errorMessages;
            this.snackbarColor = 'error';
            this.snackbar = true;
          });
      }
      this.loading = false;
    },
  },
};
</script>
<style>
#newEmployee {
  height: calc(100vh - var(--toolbar-height)) !important;
  overflow-y: scroll;
}
</style>

